import { render, staticRenderFns } from "./TextAnalysis.vue?vue&type=template&id=579a77d5&scoped=true"
import script from "./TextAnalysis.vue?vue&type=script&lang=js"
export * from "./TextAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579a77d5",
  null
  
)

export default component.exports